import { useQuery } from '@tanstack/react-query';
import type { AiInstructionUser } from '@/types/ai-instructions';
import { apiClient } from '@/lib/api-client';

interface InstructionUsersResponse {
  users: AiInstructionUser[];
}

export function useInstructionUsers(
  organizationId: string,
  contentId: string | null,
  // Scope the modal to the clicked DataTable row's category so its list matches
  // the cell count (KIR-3356). Three states: `undefined` = no scope (all
  // categories); `null` = the untyped (null-category) row → sent as
  // `fileCategoryNull=true`; string = that category.
  fileCategory: string | null | undefined
) {
  return useQuery<InstructionUsersResponse, Error>({
    queryKey: ['ai-instruction-users', organizationId, contentId, fileCategory],
    queryFn: async (): Promise<InstructionUsersResponse> => {
      if (!contentId) {
        throw new Error('Content ID is required');
      }

      const response = await apiClient.get(
        `/organizations/${organizationId}/ai-instructions/${contentId}/users`,
        {
          params:
            fileCategory === undefined
              ? undefined
              : fileCategory === null
                ? { fileCategoryNull: 'true' }
                : { fileCategory },
        }
      );

      return response as unknown as InstructionUsersResponse;
    },
    enabled: !!organizationId && !!contentId,
  });
}
